"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/objectSpread2"));

var _vuex = require("vuex");

var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));

var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));

var _Screenfull = _interopRequireDefault(require("@/components/Screenfull"));

var _SizeSelect = _interopRequireDefault(require("@/components/SizeSelect"));

var _Download = _interopRequireDefault(require("@/components/Download"));

var _Notice = _interopRequireDefault(require("@/components/Notice"));

var _password = _interopRequireDefault(require("@/views/profile/password.vue"));

var _Cti = _interopRequireDefault(require("./Cti"));

var _profile = require("@/api/profile");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      changeVisible: false //是否展示密码修改框

    };
  },
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default,
    Screenfull: _Screenfull.default,
    SizeSelect: _SizeSelect.default,
    Download: _Download.default,
    Notice: _Notice.default,
    Cti: _Cti.default,
    password: _password.default
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["sidebar", "name", "avatar", "device"])), {}, {
    cusId: {
      get: function get() {
        return this.$store.state.panel.customerId;
      }
    },
    user: function user() {
      return this.$store.state.user;
    },
    panelTitle: {
      get: function get() {
        return this.$store.state.panel.panelTitle;
      }
    },
    panelVisible: {
      get: function get() {
        return this.$store.state.panel.panelVisible;
      },
      set: function set(value) {
        this.$store.commit("updatePanel", value);
      }
    },
    panelType: function panelType() {
      return this.$store.state.panel.panelType;
    }
  }),
  watch: {},
  methods: {
    handleChangePwd: function handleChangePwd() {
      this.$refs.password.showVisible(0);
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    logout: function logout() {
      var _this = this;

      if (cicGlobal.eventSocket) {
        cicGlobal.logout();
        cicGlobal.disconnect();
      }

      this.$store.dispatch("LogOut").then(function () {
        _this.$router.push("/login?redirect=".concat(_this.$route.fullPath));

        location.reload();
      });
    },
    togglePanel: function togglePanel() {
      this.$store.commit("togglePanel");
    },
    showPanel: function showPanel() {
      return this.panelVisible;
    }
  }
};
exports.default = _default;